import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  Tabs,
  Tab,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchHistory,
  fetchId,
  fetchIdNoloading,
  fetchTemplate,
  selectId,
  selectIdHistory,
  selectLoading,
  uploadItem,
  uploadValidate,
} from "./productSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  showDialog,
  checkEmptyFields,
  validatePrice,
  paramsMasterAll,
  setOptionsMaster,
  formatterStatus,
  columnsOrder,
  formatCurrency,
  formatQuantity,
  akhirBulan,
  awalBulan,
  formatDate,
  useForceUpdate,
  formatTanggal,
  paramsActiveType,
  statusFormatter,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import SVG from "react-inlinesvg";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { fetchUom, selectUom } from "../uom/uomSlice";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { InputDateRange } from "../../utility/InputDateRange";
import { NavLink } from "react-router-dom";
import InputNumber from "../../utility/InputNumber";
import { useLocation } from "react-router-dom";

export const ProductCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataIdHistory = useSelector(selectIdHistory);
  const dataUom = useSelector(selectUom);
  const { id } = useParams();
  const ref = useRef();
  const { SearchBar } = Search;
  const forceUpdate = useForceUpdate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const additionalParam = queryParams.get("additionalParam");
  const additionalParamStart = queryParams.get("startDate");
  const additionalParamEnd = queryParams.get("endDate");

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [uom, setUom] = useState("");
  const [altUom, setAltUom] = useState("");
  const [altUomCode, setAltUomCode] = useState("");
  const [tableData, setTableData] = useState([]);
  const [tableUom, setTableUom] = useState([]);
  const [tableDataHistory, setTableDataHistory] = useState([]);
  const [optionsUom, setOptionUom] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [showUom, setShowUom] = useState("");
  const [qtyRatio, setQtyRatio] = useState("");
  const [qtyBase, setQtyBase] = useState("");
  const [status, setStatus] = useState(true);

  const [startOrder, setStartOrder] = useState(formatTanggal(awalBulan));
  const [endOrder, setEndOrder] = useState(formatTanggal(akhirBulan));

  const [activeTab, setActiveTab] = useState("Group");
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingIndex, setIsEditingIndex] = useState(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  if (additionalParam === "History") {
    window.scrollTo(0, 850);
  }

  const paramsFilterRange = {
    ...paramsMasterAll,
    start_order_date: startOrder,
    end_order_date: endOrder,
    product_id: id,
  };

  const paramsId = {
    product_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchUom(paramsMasterAll));

      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataUom.length > 0) {
      setOptionsMaster(dataUom, setOptionUom, "uom_id", "uom_code");
    }
  }, [dataUom]);

  useEffect(() => {
    if (dataId) {
      setActiveTab(additionalParam === null ? "Group" : "History");

      setCode(dataId?.product_code);
      setName(dataId?.product_name);
      setUom(dataId?.uom_id);
      setBarcode(dataId?.barcode_value);
      setStatus(dataId?.is_active);
      const initData = dataId?.prices?.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          price: parseInt(item.price),
        };
      });
      setTableData(initData);
      const initData2 = dataId?.alternate_uoms?.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });
      setTableUom(initData2);

      if (additionalParam === "History") {
        setStartOrder(additionalParamStart);
        setEndOrder(additionalParamEnd);
        CallApi(
          {
            ...paramsMasterAll,
            start_order_date: additionalParamStart,
            end_order_date: additionalParamEnd,
            product_id: id,
          },
          fetchHistory,
          dispatch
        );
      } else {
        CallApi(paramsFilterRange, fetchHistory, dispatch);
      }
    }
  }, [dataId]);
  useEffect(() => {
    if (dataIdHistory) {
      const initData = dataIdHistory?.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          sales_name: item.company_sales_code + "-" + item.company_sales_name,
        };
      });
      setTableDataHistory(initData);
    }
  }, [dataIdHistory]);

  const handleSave = async () => {
    let hasError = false; // Variable to track if there is any error

    const fields = [
      { value: code, message: "input Product Code", valid: true },
      { value: name, message: "input Product Name", valid: true },
      { value: uom, message: "input Product Uom", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    const params = {
      company_id: user.company_id,
      product_id: id,
      product_code: code,
      product_name: name,
      barcode_value: barcode,
      uom_id: uom,
      alternate_uoms: tableUom,
      is_active: status,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleChangeUom = createChangeHandler(setUom);
  const handleChangeStatus = createChangeHandler(setStatus);
  const handleChangeAltUom = async (e) => {
    console.log(e);
    if (e === null) {
      e = undefined;
      setAltUom("");
      setAltUomCode("");
    } else {
      setAltUomCode(e.label);
      setAltUom(e.value);
    }
  };

  // upload
  const [showUpload, setShowUpload] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [tableUpload, setTableUpload] = useState([]);

  const handleShowUpload = (data) => {
    setShowUpload(true);
  };

  const handleCloseUpload = () => {
    setTableUpload([]);
    setShowUpload(false);
  };

  const handleUpload = async () => {
    const params = tableUpload.filter(
      (entry) => entry.status_validation === "Success"
    );

    if (params.length === 0) {
      return showDialog("Please upload data first");
    }

    try {
      const response = await dispatch(uploadItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchId, dispatch);
        handleCloseUpload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileUpload(selectedFile);
    validateFile(selectedFile);
  };

  const validateFile = async (file) => {
    if (file) {
      try {
        const response = await dispatch(uploadValidate(file));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const initData = response.payload.data.data.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          });
          setTableUpload(initData);
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
        console.log(error.message);
      }
    } else {
      console.log("No file uploaded");
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "uom",
      dataField: "uom_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "is active",
      dataField: "is_active",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: statusFormatter,
    },

    {
      text: "status",
      dataField: "status_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },
    {
      text: "message",
      dataField: "message_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];
  const handleDownload = async () => {
    const params = {
      file_type: "PRODUCT",
    };
    try {
      const response = await dispatch(fetchTemplate(params));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/xlsx",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "PRODUCT.xlsx";
        link.click();
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const columnsHistory = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      footer: "",
    },

    {
      text: "order no",
      dataField: "order_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "200px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
          >
            <NavLink
              className="menu-link"
              to={`/transaction/order/detail/${row.visit_order_id}`}
            >
              {cell}
            </NavLink>
          </span>
        );
      },
      footer: "",
    },
    {
      text: "order date",
      dataField: "order_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "130px" },
      formatter: formatDate,
      footer: "",
    },
    {
      text: "store name",
      dataField: "customer_store_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      footer: "",
    },

    {
      text: "sales name",
      dataField: "sales_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      footer: "",
    },
    {
      text: "unit price",
      dataField: "unit_price",
      align: "right",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatCurrency,
      footer: "",
    },
    {
      text: "qty",
      dataField: "quantity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "120px" },
      align: "right",
      footer: (columnData) => {
        const parsedData = columnData.map((item) => parseFloat(item));
        const total = parsedData.reduce((acc, item) => acc + item, 0);
        if (total === 0) {
          return null; // Menyembunyikan footer jika total harga adalah 0
        }
        return formatQuantity(total);
      },
      footerAlign: (column, colIndex) => "right",
    },

    {
      text: "total price",
      dataField: "total_price",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatCurrency,
      align: "right",
      footer: (columnData) => {
        const parsedData = columnData.map((item) => parseFloat(item));
        const total = parsedData.reduce((acc, item) => acc + item, 0);
        if (total === 0) {
          return null; // Menyembunyikan footer jika total harga adalah 0
        }
        return formatCurrency(total);
      },
      footerAlign: (column, colIndex) => "right",
    },
  ];
  const handleQty = (e, row, rowIndex, formatExtraData) => {
    if (row.price < 0) {
      row.price = 0;
      forceUpdate();
      return;
    }
  };

  const inputQtyFormmater = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="number"
        className="input-qty"
        step="any"
        value={row.price}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
      />
    );
  };
  const columnsData = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      editable: false,
    },

    {
      text: "pricelist group",
      dataField: "customer_group",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      editable: false,
    },
    {
      text: "pricelist group name",
      dataField: "customer_group_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      editable: false,
    },
    {
      text: "UOM",
      dataField: "uom_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      editable: false,
    },
    {
      text: "price",
      dataField: "price",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      editable: false,
      formatter: formatCurrency,
      align: "right",
    },
  ];

  // alt uom

  const handleCloseAltUom = () => {
    setShowUom(false);
    setAltUom("");
    setAltUomCode("");
    setQtyRatio("");
    setQtyBase("");
    setIsEditing(false);
    setIsEditingIndex(null);
  };

  const handleSubmitAltUom = async () => {
    const fields = [
      { value: altUom, message: "input UOM", valid: true },
      { value: qtyRatio, message: "input Qty Ratio", valid: true },
      { value: qtyBase, message: "input Qty Base", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    setTableUom((prevTableUom) => {
      // If adding a new entry (not editing)
      if (!isEditing) {
        const isDuplicate = prevTableUom.some(
          (item) => item.uom_code === altUomCode
        );

        if (isDuplicate) {
          showDialog("UOM code must be unique.");
          return prevTableUom; // Do not update the table if duplicate is found
        }

        // Add new entry
        const updatedTable = [
          ...prevTableUom,
          {
            uom_id: altUom,
            uom_code: altUomCode,
            quantity_ratio: qtyRatio,
            quantity_base: qtyBase,
          },
        ];

        // Reindex the table
        return updatedTable.map((item, index) => ({
          ...item,
          no: index + 1, // Reindex starting from 1
        }));
      }
      // If editing an existing entry
      else {
        const isDuplicate = prevTableUom.some(
          (item, index) =>
            item.uom_code === altUomCode && index !== isEditingIndex
        );

        if (isDuplicate) {
          showDialog("UOM code must be unique.");
          return prevTableUom; // Do not update the table if duplicate is found
        }

        // Update the existing entry at the editIndex
        const updatedTable = prevTableUom.map((item, index) =>
          index === isEditingIndex
            ? {
                ...item,
                uom_id: altUom,
                uom_code: altUomCode,
                quantity_ratio: qtyRatio,
                quantity_base: qtyBase,
              }
            : item
        );

        return updatedTable.map((item, index) => ({
          ...item,
          no: index + 1, // Reindex starting from 1
        }));
      }
    });

    handleCloseAltUom();
  };

  const handleDeleteUom = (noToDelete) => {
    setTableUom((prevData) => {
      // Filter data untuk menghapus item berdasarkan properti 'no'
      const updatedTableData = prevData.filter(
        (item) => item.no !== noToDelete
      );

      // Tambahkan kembali nomor urut
      return updatedTableData.map((item, index) => ({
        ...item,
        no: index + 1,
      }));
    });
  };

  const actionFormatter = (e, row, rowIndex) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            onClick={() => {
              setAltUom(row.uom_id);
              setAltUomCode(row.uom_code);
              setQtyRatio(parseInt(row.quantity_ratio));
              setQtyBase(parseInt(row.quantity_base));
              setShowUom(true);
              setIsEditing(true);
              setIsEditingIndex(rowIndex);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-secondary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </div>
        </OverlayTrigger>

        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={(e) => handleDeleteUom(row.no)}
          >
            <span className="svg-icon svg-icon-md svg-icon-danger">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsUom = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      editable: false,
    },

    {
      text: "uom",
      dataField: "uom_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      editable: false,
      formatter: (cell, row) => (
        <div>
          <span>
            <b>{row.uom_code}</b>
          </span>
          <br />
          <span>{row.uom_description}</span>
        </div>
      ),
    },
    {
      text: "qty Ratio",
      dataField: "quantity_ratio",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "qty Base",
      dataField: "quantity_base",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Action",
      dataField: "action",
      align: "center",
      formatter: actionFormatter,
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create Product" : "Edit Product"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            {id === undefined && (
              <Button
                className="btn btn-warning mr-3"
                onClick={handleShowUpload}
              >
                Upload
              </Button>
            )}

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Product Code<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setCode(e.target.value)}
                      value={code}
                      disabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Product Name <b className="color-red">*</b>{" "}
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Barcode Value</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setBarcode(e.target.value)}
                      value={barcode}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Status <b className="color-red">*</b>{" "}
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={paramsActiveType}
                      value={getValueStatus(status, paramsActiveType)}
                      placeholder="Select ..."
                      onChange={handleChangeStatus}
                      isDisabled={id === undefined}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Base UOM <b className="color-red">*</b>{" "}
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsUom}
                      value={getValueStatus(uom, optionsUom)}
                      placeholder="Select ..."
                      onChange={handleChangeUom}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          {id !== undefined && (
            <Tabs
              defaultActiveKey="Group"
              id="uncontrolled-tab-example"
              className="mb-5"
              activeKey={activeTab}
              onSelect={(e) => setActiveTab(e)}
            >
              <Tab eventKey="Group" title="Pricelist Group">
                <ToolkitProvider
                  keyField="no"
                  data={tableData}
                  columns={columnsData}
                  search
                >
                  {(props) => (
                    <div className="mt-5">
                      <Row>
                        <Col>
                          {/* <Form.Group as={Row}>
                            <Form.Label column sm={3}>
                              <b>Group</b>
                            </Form.Label>
                          </Form.Group> */}
                        </Col>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container ">
                        <BootstrapTable
                          // wrapperClasses="table-responsive"
                          classes="table table-head-custom table-vertical-center"
                          bootstrap4
                          bordered={true}
                          noDataIndication="Data Not Found"
                          {...props.baseProps}
                          cellEdit={cellEditFactory({
                            mode: "click",
                            blurToSave: true,
                          })}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </Tab>
              <Tab eventKey="Alternate UOM" title="Alternate UOM">
                <ToolkitProvider
                  keyField="no"
                  data={tableUom}
                  columns={columnsUom}
                  search
                >
                  {(props) => (
                    <div className="mt-5">
                      <div className="d-flex justify-content-between mb-3">
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => setShowUom(true)}
                        >
                          Add UOM
                        </button>
                        <div className="float-right">
                          <SearchBar
                            {...props.searchProps}
                            placeholder="Search .."
                          />
                        </div>
                      </div>
                      <div className="table-container ">
                        <BootstrapTable
                          // wrapperClasses="table-responsive"
                          classes="table table-head-custom table-vertical-center"
                          bootstrap4
                          bordered={true}
                          noDataIndication="Data Not Found"
                          {...props.baseProps}
                          // cellEdit={cellEditFactory({
                          //   mode: "click",
                          //   blurToSave: true,
                          // })}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </Tab>
              <Tab eventKey="History" title="History">
                <ToolkitProvider
                  keyField="no"
                  data={tableDataHistory}
                  columns={columnsHistory}
                  search
                >
                  {(props) => (
                    <div className="mt-5">
                      <Row>
                        <Col>
                          <Form.Group as={Row}>
                            <Form.Label column sm={3}>
                              <b>Order Date</b>
                            </Form.Label>
                            <Col sm={6}>
                              <InputDateRange
                                setEndDate={setEndOrder}
                                setStartDate={setStartOrder}
                                endDate={endOrder}
                                startDate={startOrder}
                                CallApi={fetchHistory}
                                paramsFilter={paramsFilterRange}
                                paramsStart={"start_order_date"}
                                paramsEnd={"end_order_date"}
                                hidden={true}
                              />
                            </Col>
                          </Form.Group>
                        </Col>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container ">
                        <BootstrapTable
                          // wrapperClasses="table-responsive"
                          classes="table table-head-custom table-vertical-center"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                          noDataIndication="Data Not Found"
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </Tab>
            </Tabs>
          )}
        </CardBody>
      </Card>

      <Modal
        show={showUpload}
        onHide={handleCloseUpload}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    File <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    ref={ref}
                    type="file"
                    label="Input "
                    onChange={handleFileChange}
                    custom
                    accept=".xlsx"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Button variant="warning" onClick={() => handleDownload()}>
                Download Template
              </Button>
            </Col>
          </Form.Group>

          {tableUpload.length > 0 && (
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-5"
              bootstrap4
              keyField="no"
              data={tableUpload}
              columns={columns}
              hover
              striped
              noDataIndication="Data Not Found"
            ></BootstrapTable>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseUpload()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleUpload}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUom}
        onHide={handleCloseAltUom}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Alternate UOM</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    UOM <b className="color-red">*</b>{" "}
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsUom}
                    value={getValueStatus(altUom, optionsUom)}
                    placeholder="Select ..."
                    onChange={handleChangeAltUom}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Qty Ratio <b className="color-red">*</b>{" "}
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    onChange={(e) => setQtyRatio(e.target.value)}
                    value={qtyRatio}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Qty Base <b className="color-red">*</b>{" "}
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    onChange={(e) => setQtyBase(e.target.value)}
                    value={qtyBase}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseAltUom()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleSubmitAltUom}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
